import { computed, type ComputedRef } from 'vue'
import type { UserDto, UserRole } from '~/services/api/generated'
import { normalizeIdentity } from '~/utils/normalizeIdentity'
import { useLogger } from '~/composables/useLogger'
import { resolveRoleNames } from '~/utils/resolveRoleNames'
import { refreshCurrentIdentity } from '~/utils/refreshCurrentIdentity'

// Identity readers receive validated state; refreshes commit only the current credential.
export const useIdentity = () => {
  const nuxtApp = useNuxtApp()
  const logger = useLogger('useIdentity')
  const sanctumUser = useSanctumUser()
  const sanctumAuth = useSanctumAuth()

  const identity: ComputedRef<UserDto | null> = computed(() =>
    normalizeIdentity(sanctumUser.value, logger)
  )

  const roles: ComputedRef<UserRole[]> = computed(() => resolveRoleNames(identity.value))

  const isTwoFactorConfirmed: ComputedRef<boolean> = computed(
    () => identity.value?.two_factor_enabled === true
  )

  return {
    identity,
    roles,
    isTwoFactorConfirmed,
    isAuthenticated: sanctumAuth.isAuthenticated,
    refreshIdentity: async (): Promise<void> => {
      await refreshCurrentIdentity(nuxtApp, logger)
    },
    login: sanctumAuth.login,
    logout: sanctumAuth.logout
  }
}
